/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './send-oracle-cart.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/forms';
import * as i3 from '../../../../app/components/send-oracle-cart/send-oracle-cart.component';
import * as i4 from '../../../../app/storage/storage';
const styles_SendOracleCartComponent:any[] = [i0.styles];
export const RenderType_SendOracleCartComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_SendOracleCartComponent,data:{}});
export function View_SendOracleCartComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵqud(402653184,1,{testFormElement:0}),(_l()(),i1.ɵeld(1,0,(null as any),
      (null as any),1,'h1',([] as any[]),(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['Loading cart'])),
      (_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵeld(4,0,[[1,0],['testForm',
          1]],(null as any),7,'form',[['enctype','application/x-www-form-urlencoded'],
          ['id','cxml_form'],['method','POST'],['novalidate','']],[[8,'action',4],
          [2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
              (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
          [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],[[(null as any),
          'submit'],[(null as any),'reset']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('submit' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,6).onSubmit($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('reset' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,6).onReset()) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(5,16384,(null as any),0,i2.ɵbf,([] as any[]),
          (null as any),(null as any)),i1.ɵdid(6,16384,(null as any),0,i2.NgForm,[[8,
          (null as any)],[8,(null as any)]],(null as any),(null as any)),i1.ɵprd(2048,
          (null as any),i2.ControlContainer,(null as any),[i2.NgForm]),i1.ɵdid(8,16384,
          (null as any),0,i2.NgControlStatusGroup,[i2.ControlContainer],(null as any),
          (null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(10,
          0,(null as any),(null as any),0,'input',[['name','cxml-urlencoded'],['type',
              'hidden']],[[8,'value',0]],(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵted(-1,
          (null as any),['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],(null as any),
      (_ck,_v) => {
        var _co:i3.SendOracleCartComponent = _v.component;
        const currVal_0:any = _co.buyer_form_post_url;
        const currVal_1:any = i1.ɵnov(_v,8).ngClassUntouched;
        const currVal_2:any = i1.ɵnov(_v,8).ngClassTouched;
        const currVal_3:any = i1.ɵnov(_v,8).ngClassPristine;
        const currVal_4:any = i1.ɵnov(_v,8).ngClassDirty;
        const currVal_5:any = i1.ɵnov(_v,8).ngClassValid;
        const currVal_6:any = i1.ɵnov(_v,8).ngClassInvalid;
        const currVal_7:any = i1.ɵnov(_v,8).ngClassPending;
        _ck(_v,4,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
            currVal_7);
        const currVal_8:any = _co.xml;
        _ck(_v,10,0,currVal_8);
      });
}
export function View_SendOracleCartComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-send-oracle-cart',
      ([] as any[]),(null as any),(null as any),(null as any),View_SendOracleCartComponent_0,
      RenderType_SendOracleCartComponent)),i1.ɵdid(1,4308992,(null as any),0,i3.SendOracleCartComponent,
      [i4.Storage],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const SendOracleCartComponentNgFactory:i1.ComponentFactory<i3.SendOracleCartComponent> = i1.ɵccf('app-send-oracle-cart',
    i3.SendOracleCartComponent,View_SendOracleCartComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3N0ZXBoL0RvY3VtZW50cy9kZXYvbmVuZGkvbmVuZGktdmlzaW9uLWZyb250L3NyYy9hcHAvY29tcG9uZW50cy9zZW5kLW9yYWNsZS1jYXJ0L3NlbmQtb3JhY2xlLWNhcnQuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL1VzZXJzL3N0ZXBoL0RvY3VtZW50cy9kZXYvbmVuZGkvbmVuZGktdmlzaW9uLWZyb250L3NyYy9hcHAvY29tcG9uZW50cy9zZW5kLW9yYWNsZS1jYXJ0L3NlbmQtb3JhY2xlLWNhcnQuY29tcG9uZW50LnRzIiwibmc6Ly8vVXNlcnMvc3RlcGgvRG9jdW1lbnRzL2Rldi9uZW5kaS9uZW5kaS12aXNpb24tZnJvbnQvc3JjL2FwcC9jb21wb25lbnRzL3NlbmQtb3JhY2xlLWNhcnQvc2VuZC1vcmFjbGUtY2FydC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL1VzZXJzL3N0ZXBoL0RvY3VtZW50cy9kZXYvbmVuZGkvbmVuZGktdmlzaW9uLWZyb250L3NyYy9hcHAvY29tcG9uZW50cy9zZW5kLW9yYWNsZS1jYXJ0L3NlbmQtb3JhY2xlLWNhcnQuY29tcG9uZW50LnRzLlNlbmRPcmFjbGVDYXJ0Q29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGgxPkxvYWRpbmcgY2FydDwvaDE+XG48Zm9ybVxuICBpZD1cImN4bWxfZm9ybVwiXG4gIG1ldGhvZD1cIlBPU1RcIlxuICBbYWN0aW9uXT1cImJ1eWVyX2Zvcm1fcG9zdF91cmxcIlxuICBlbmN0eXBlPVwiYXBwbGljYXRpb24veC13d3ctZm9ybS11cmxlbmNvZGVkXCJcbiAgI3Rlc3RGb3JtXG4+XG4gIDxpbnB1dCB0eXBlPVwiaGlkZGVuXCIgbmFtZT1cImN4bWwtdXJsZW5jb2RlZFwiIFt2YWx1ZV09XCJ4bWxcIiAvPlxuPC9mb3JtPlxuPCEtLSA8c2NyaXB0IHR5cGU9XCJ0ZXh0L2phdmFzY3JpcHRcIj5cbiAgZG9jdW1lbnQuZ2V0RWxlbWVudEJ5SWQoXCJjeG1sX2Zvcm1cIikuc3VibWl0KCk7XG48L3NjcmlwdD4gLS0+XG4iLCI8YXBwLXNlbmQtb3JhY2xlLWNhcnQ+PC9hcHAtc2VuZC1vcmFjbGUtY2FydD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs2RENBQTtNQUFBO01BQUEsOEJBQUk7TUFBaUIsMENBQ3JCO1VBQUE7VUFBQTtVQUFBO2NBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7TUFBQSx1Q0FBQTtVQUFBLG9DQUFBO1VBQUEsc0VBQUE7VUFBQSxvRUFBQTtVQUFBO1VBQUEsZUFNQyw0Q0FDQztVQUFBO2NBQUE7VUFBQSxnQkFBNEQsMENBQ3ZEO1VBQUEsdUJBR007OztRQVJYO1FBSEY7UUFBQTtRQUFBO1FBQUE7UUFBQTtRQUFBO1FBQUE7UUFBQSxXQUdFLFVBSEY7WUFBQSxTQUFBO1FBTzhDO1FBQTVDLFlBQTRDLFNBQTVDOzs7O29CQ1JGO01BQUE7d0NBQUEsVUFBQTtNQUFBO0lBQUE7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/components/send-oracle-cart/send-oracle-cart.component.ngfactory.ts